import React from "react";
import { Flex, Image, Button, AddIcon } from "@fluentui/react-northstar";
import LocationsSettingsImage from "../../../assets/images/undraw_calling_kpbp.svg";
import SettingsLocationList from "../../molecules/SettingsLocationsList";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { useMst } from "../../../hooks/useMst";
import Constants from "../../../constants/text-constants";

const LocationsSettings = observer((props) => {
    const { locations, onAddLocationClick, onEditLocationClick, onDeleteLocationClick } = props;
    const { permissionStore } = useMst();
    const hasAddLocPermissions = permissionStore.havePermissions("Locations", ["Create"]);

    return (
        <Flex className="location-settings-container" data-testid="locationsSettings" gap="gap.large" column>
            <Image
                fluid
                src={LocationsSettingsImage}
                data-testid={"LocationsSettingsImage"}>
            </Image>
            <Flex hAlign="center">
                <Button
                    data-testid="addLocationBtn"
                    disabled={!hasAddLocPermissions}
                    icon={(<AddIcon />)}
                    content={Constants.ADD_LOCATION}
                    primary
                    onClick={onAddLocationClick}
                />
            </Flex>
            <SettingsLocationList
                onDeleteLocationClick={onDeleteLocationClick}
                onEditClicked={onEditLocationClick}
                locations={locations}>
            </SettingsLocationList>
        </Flex >
    );
})

LocationsSettings.propTypes = {
    locations: PropTypes.array,
    onAddLocationClick: PropTypes.func,
};

LocationsSettings.defaultProps = {
    locations: [],
};

export default LocationsSettings;